import { render } from "./UpperBanner.vue?vue&type=template&id=bc628514"
import script from "./UpperBanner.vue?vue&type=script&lang=js"
export * from "./UpperBanner.vue?vue&type=script&lang=js"

import "./UpperBanner.vue?vue&type=style&index=0&id=bc628514&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__